<template>
  <div id="OpenApiSetting" class="bg-color1" style="height:calc(100vh);">
    <div ref="app_head" class="col-12 lh40 bg-color-white b-s-2 pl5 pr5 fixed-t">
        <div class="col-3 f18" @click="$router.back(-1)"><i class="iconfont icon-31fanhui1 color-primary"></i></div>
        <div class="col-6 t-c color-primary"><span class="f24 fw">O</span>pen API {{ pageData.open_id }}</div>
        <div class="col-3 t-r f22 pr3"></div>
    </div>
    <div class="h4"></div>
    <div class="col-12 pt3 pb10 bg-color1 f14" style="overflow-y: auto;">
      <div class="col-12 bg-color-primary color-white pl15 pr15 pt20 pb20">
        <div class="col-12 lh24"> 
          <span class="">APPID:</span>
          <span class="">{{ pageData.appid }}</span>
        </div>
        <div class="col-12 lh24">
          <span class="">Open_Key: <i class="ml5 iconfont icon-shangpintongbu" @click="refresh_open_key()"></i></span>
          <span class="el2">{{ pageData.open_key }}</span>
        </div>
      </div>
      <div class="col-12 bb1 bt1" @click="go_cate()">
        <div class="col-12 bg-color-white pl5 pr5 pt15 pb15">
            <div class="col-10 pl10">
              Categorías
            </div>
            <div class="col-2 color-muted t-r pr5">
              <i class="iconfont icon-31fanhui2"></i>
            </div>
        </div>
      </div>
      <div class="col-12 bb1" @click="go_product()">
        <div class="col-12 bg-color-white pl5 pr5 pt15 pb15">
            <div class="col-10 pl10">
              Productos
            </div>
            <div class="col-2 color-muted t-r pr5">
              <i class="iconfont icon-31fanhui2"></i>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'OpenApiSetting',
  data () {
    return {
      pageData: {}
    }
  },
  created: function () {
    this.getData();
  },
  methods: {
    getData: function () {
      let post_data = {};
      post_data.open_id = this.$route.query.open_id;
      this.post(this.api_url + 'manage/open_api_data', post_data).then((res)=>{
        if(res.status == 1){
          console.log(res.data);
          this.pageData = res.data;
        }
      })
    },
    go_cate() {
      this.$router.push({name: 'M_OpenApiCateList', query: {open_id: this.pageData.open_id}});
    },
    go_product() {
      this.$router.push({name: 'M_OpenApiProductList', query: {open_id: this.pageData.open_id}});
    },
    refresh_open_key() {
      let post_data = {};
      post_data.open_id = this.pageData.open_id;
      this.post(this.api_url + 'manage/refresh_open_key', post_data).then((res)=>{
        if(res.status == 1){
          this.$store.commit('setAlert',{type:'success',msg: "Success"});
          this.getData();
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Main/OpenApiSetting.vue